import Model from './Model';

export default class Universal extends Model {
  resource() {
    return 'universal';
  }

  delete() {
    if (!this.hasId()) {
      throw new Error('This model has an empty ID');
    }

    return this.request({
      url: this.endpoint(),
      method: 'DELETE',
      params: this,
    }).then((response) => response);
  }
}
